import {PaymentFlowType} from 'modules/offerCheck/types'

import {BookingStatusLink} from '@vio/core/src/api-types/bovio/response/booking_status'
import {LinkType} from '@vio/core/src/booking/types/Link'
import {ActionLinkTypes} from '@vio/core/src/offer/types/actionLink'

const findLinkByType = (
  linkType: ActionLinkTypes,
  links: LinkType[] | BookingStatusLink[] = []
) => links.find(link => link.type === linkType)

export const getBookingFinalizationLink = (
  links: LinkType[] | BookingStatusLink[] = []
) => findLinkByType(ActionLinkTypes.BOOKING_FINALIZATION_ASYNC, links)

export const getExistingBookingConfirmationLink = (
  links: LinkType[] | BookingStatusLink[] = []
) => findLinkByType(ActionLinkTypes.BOOKING_PAYMENT_CONFIRMATION, links)

const getChargeLaterFinalizationLink = (
  links: LinkType[] | BookingStatusLink[] = []
) => findLinkByType(ActionLinkTypes.CHARGE_LATER_BOOKING_FINALIZATION, links)

export const getBookingStatusLink = (
  links: LinkType[] | BookingStatusLink[] = []
) => findLinkByType(ActionLinkTypes.BOOKING_STATUS, links)

export const getBookingCreationLink = (
  links: LinkType[] | BookingStatusLink[] = [],
  flowType?: PaymentFlowType
) =>
  flowType === PaymentFlowType.SplitBooking
    ? findLinkByType(ActionLinkTypes.SB_BUNDLE_BOOKING_CREATION, links)
    : findLinkByType(ActionLinkTypes.BOOKING_CREATION_ASYNC, links)

export const getChargeLaterBookingCreationLink = (
  links: LinkType[] | BookingStatusLink[] = []
) => findLinkByType(ActionLinkTypes.CHARGE_LATER_BOOKING_CREATION, links)

export const getBookingPaymentLink = (
  links: LinkType[] | BookingStatusLink[] = []
) => findLinkByType(ActionLinkTypes.BOOKING_PAYMENT, links)

export const getBookingConfirmationNotificationLink = (
  links: LinkType[] | BookingStatusLink[] = []
) => findLinkByType(ActionLinkTypes.BOOKING_CONFIRMATION_NOTIFICATION, links)

export const getManageBookingLink = (
  links: LinkType[] | BookingStatusLink[] = []
) => findLinkByType(ActionLinkTypes.MANAGE_BOOKING, links)

interface getFinalizationLinkParams {
  isExistingBooking: boolean
  isChargeLaterBookingCreation: boolean
  links?: LinkType[] | BookingStatusLink[]
}
export const getFinalizationLink = ({
  isExistingBooking,
  isChargeLaterBookingCreation,
  links
}: getFinalizationLinkParams) => {
  if (isExistingBooking) return getExistingBookingConfirmationLink(links)
  if (isChargeLaterBookingCreation) return getChargeLaterFinalizationLink(links)
  return getBookingFinalizationLink(links)
}

export const getPaymentRedirectLink = (
  links: LinkType[] | BookingStatusLink[] = []
) => findLinkByType(ActionLinkTypes.PAYMENT_REDIRECT, links)

export const getPaymentSettingsLink = (
  links: LinkType[] | BookingStatusLink[] = []
) => findLinkByType(ActionLinkTypes.PAYMENT_SETTINGS, links)

export const getPaymentSessionsLink = (
  links: LinkType[] | BookingStatusLink[] = []
) => findLinkByType(ActionLinkTypes.PAYMENT_SESSIONS, links)
